import useMountEffect from "@p-ban/common/src/hooks/useMountEffect"

import estimateApi from "../../../../../api/estimate/estimateApi"

/**
 * webチェッカーアップロードデータの削除
 */
const useDeleteDrcData = () => {
  useMountEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get("preservDrcData") !== "true") {
      estimateApi.deleteDrcData()
    }
  })
}

export default useDeleteDrcData
